! function(a) {
    a.fn.directionalHover = function(b) {
        function c(a, b, c, e, f, g, h, i) {
            var n = 0;
            g / 2 >= e - i && (n ^= j), c - h >= f / 2 && (n ^= k), e - i > g / 2 && (n ^= l), f / 2 > c - h && (n ^= m), d(n, a, b, c - h, e - i, f / 2, g / 2)
        }

        function d(a, b, c, d, i, j, k) { e(a, n) ? f(d, i, j, k) ? h(b, c, 0, 2 * -j) : h(b, c, 2 * -k, 0) : e(a, o) ? g(d, i, j, k) ? h(b, c, 2 * -k, 0) : h(b, c, 0, 2 * j) : e(a, p) ? g(d, i, j, k) ? h(b, c, 0, 2 * -j) : h(b, c, 2 * k, 0) : e(a, q) && (f(d, i, j, k) ? h(b, c, 2 * k, 0) : h(b, c, 0, 2 * j)) }

        function e(a, b) { return (a & b) === b }

        function f(a, b, c, d) { return 0 > d * a - c * b }

        function g(a, b, c, d) { return 0 > c * (b - d) + d * a - c * d }

        function h(a, b, c, d) { "in" === b ? a.animate({ top: c, left: d }, 0, function() { a.stop().animate({ top: 0, left: 0 }, i.speed, i.easing) }) : "out" === b && a.animate({ top: 0, left: 0 }, 0, function() { a.stop().animate({ top: c, left: d }, i.speed, i.easing) }) }
        var i = a.extend({}, a.fn.directionalHover.defaults, b),
            j = 1,
            k = 2,
            l = 4,
            m = 8,
            n = j | m,
            o = j | k,
            p = l | m,
            q = l | k;
        return this.css({ position: "relative", overflow: "hidden" }), this.find("." + i.overlay).css({ position: "absolute", top: "-100%" }), this.each(function() {
            var b = a(this);
            b.hover(function(a) { c(b.find("." + i.overlay), "in", a.pageX, a.pageY, b.width(), b.height(), Math.floor(b.offset().left), b.offset().top) }, function(a) { c(b.find("." + i.overlay), "out", a.pageX, a.pageY, b.width(), b.height(), Math.floor(b.offset().left), b.offset().top) })
        })
    }, a.fn.directionalHover.defaults = { overlay: "work-details", easing: "swing", speed: 400 }
}(jQuery);